module.exports = __webpack_public_path__ + "static/media/reviewsorg.c290fa98.png";